export const styles = {
  pdf: {
    labelColor: '#D93831',
    type: 'acrobat',
  },
  doc: {
    labelColor: '#2C5898',
    type: 'document',
  },
  docx: {
    labelColor: '#2C5898',
    type: 'document',
  },
  odt: {
    labelColor: '#2C5898',
    type: 'document',
  },
  txt: {
    labelColor: '#2C5898',
    type: 'document',
  },
  jpg: {
    labelColor: '#42a5f5',
    type: 'image',
  },
  bmp: {
    labelColor: '#42a5f5',
    type: 'image',
  },
  png: {
    labelColor: '#42a5f5',
    type: 'image',
  },
  ods: {
    labelColor: '#1A754C',
    type: 'spreadsheet',
  },
  xls: {
    labelColor: '#1A754C',
    type: 'spreadsheet',
  },
  xlsx: {
    labelColor: '#1A754C',
    type: 'spreadsheet',
  },
}
